"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = require("redux-form");

var _reactIntl = require("react-intl");

var _FieldSet = require("../../forms/FieldSet");

var _FieldSet2 = _interopRequireDefault(_FieldSet);

var _FormErrorMessage = require("../../forms/FormErrorMessage");

var _FormErrorMessage2 = _interopRequireDefault(_FormErrorMessage);

var _FormInstructionalText = require("../../forms/FormInstructionalText");

var _FormInstructionalText2 = _interopRequireDefault(_FormInstructionalText);

var _FormStubText = require("../../forms/FormStubText");

var _FormStubText2 = _interopRequireDefault(_FormStubText);

var _FormSubmit = require("../../forms/FormSubmit");

var _FormSubmit2 = _interopRequireDefault(_FormSubmit);

var _Input = require("../../forms/Input");

var _Input2 = _interopRequireDefault(_Input);

var _PassengerListItem = require("../../PassengerList/PassengerListItem");

var _forms = require("../../../utils/forms");

var _bookingCompanies = require("../../../utils/bookingCompanies");

var _pacomo = require("../../../utils/pacomo");

var _forms2 = require("../../../metadata/forms");

var _reactRedux = require("react-redux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// States


// Metadata


// Components
// React & libraries
var FORM_STATE = "MedicalInformation";

// Utils

var CHECKBOX_STATE = "MedicalInformationCheckboxes";

var MedicalInformationBase = function MedicalInformationBase(_ref) {
    var intl = _ref.intl,
        initialValues = _ref.initialValues,
        hiddenValues = _ref.hiddenValues,
        isMedicalInfoPax = _ref.isMedicalInfoPax,
        checkinUrl = _ref.checkinUrl,
        medicalInfoPax = _ref.medicalInfoPax,
        requirementsByCode = _ref.requirementsByCode,
        bookingId = _ref.bookingId,
        isFetchingRequirementData = _ref.isFetchingRequirementData,
        handleSubmit = _ref.handleSubmit,
        error = _ref.error,
        invalid = _ref.invalid,
        pristine = _ref.pristine,
        submitting = _ref.submitting,
        submitSucceeded = _ref.submitSucceeded,
        submitFailed = _ref.submitFailed,
        bookingCompanyId = _ref.bookingCompanyId,
        medicalConditionsChecked = _ref.medicalConditionsChecked,
        riskToOthersChecked = _ref.riskToOthersChecked,
        mobilityIssuesChecked = _ref.mobilityIssuesChecked,
        dietaryRestrictionsChecked = _ref.dietaryRestrictionsChecked,
        changeCheckboxValue = _ref.changeCheckboxValue;

    var _ref2 = requirementsByCode || {},
        medicalConditionsReq = _ref2.MEDICAL_CONDITIONS,
        riskToOthersReq = _ref2.RISK_TO_OTHERS,
        mobilityIssuesReq = _ref2.MOBILITY_ISSUES,
        dietaryRestrictionsReq = _ref2.DIETARY_RESTRICTIONS,
        medicalFormReq = _ref2.MEDICAL_FORM;

    var getValuePath = function getValuePath(requirement) {
        return requirement ? (0, _forms.generateValuePath)({ requirement: requirement, resourceType: "customers" }) : undefined;
    };

    var paths = {
        medicalNotesValuePath: getValuePath(medicalConditionsReq),
        dietaryRestrictionsValuePath: getValuePath(dietaryRestrictionsReq)
    };

    var getPaxName = function getPaxName(pax) {
        if (pax && pax.name && pax.name.legal_first_name && pax.name.legal_last_name) {
            return pax.name.legal_first_name + " " + pax.name.legal_last_name;
        }
        return "";
    };

    var paxName = getPaxName(medicalInfoPax);

    var handleCheckboxChange = function handleCheckboxChange(key, checked) {
        requestAnimationFrame(function () {
            changeCheckboxValue(CHECKBOX_STATE, key, !!checked);
        });
    };

    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_FormErrorMessage2.default, {
            errorCode: error,
            invalid: invalid,
            submitFailed: submitFailed,
            submitting: submitting
        }),
        !(0, _bookingCompanies.isGTBookingCompany)(bookingCompanyId) && !isMedicalInfoPax && _react2.default.createElement(_FormInstructionalText2.default, {
            instructionalText: _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formMedicalInformation.medicalInfoDifferentUser",
                    defaultMessage: "These medical requirements must be completed by {name}.",
                    values: { name: paxName }
                }),
                _react2.default.createElement("hr", null),
                _react2.default.createElement(_PassengerListItem.ReminderBtn, {
                    customerId: medicalInfoPax.id,
                    checkinUrl: checkinUrl,
                    emailAddress: medicalInfoPax.account_email
                })
            )
        }),
        _react2.default.createElement(
            "form",
            null,
            _react2.default.createElement(_FieldSet2.default, {
                requirement: medicalConditionsReq,
                fields: [{
                    id: "medicalConditions",
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "formMedicalInformation.medicalConditions",
                        defaultMessage: "Medical Conditions"
                    }),
                    field: _react2.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                        id: "medicalConditions",
                        name: paths.medicalNotesValuePath + ".medical_details",
                        hiddenValues: hiddenValues,
                        type: "textarea",
                        requirement: medicalConditionsReq,
                        customDisabled: medicalConditionsChecked,
                        helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "formMedicalInformation.medicalConditionsHelpText",
                            defaultMessage: "If you have any pre-existing medical conditions, please list them ONLY if: {ul}",
                            values: {
                                ul: _react2.default.createElement(
                                    "ul",
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: "formMedicalInformation.medicalConditionsHelpText.list",
                                        defaultMessage: "{l1} {l2} {l3}",
                                        values: {
                                            l1: _react2.default.createElement(
                                                "li",
                                                null,
                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                                    id: "formMedicalInformation.medicalConditionsHelpText.list.l1",
                                                    defaultMessage: "they affect your ability to participate in the activities on your trip(s)"
                                                })
                                            ),
                                            l2: _react2.default.createElement(
                                                "li",
                                                null,
                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                                    id: "formMedicalInformation.medicalConditionsHelpText.list.l2",
                                                    defaultMessage: "they affect your ability to travel to locations with limited access to medical care; OR"
                                                })
                                            ),
                                            l3: _react2.default.createElement(
                                                "li",
                                                null,
                                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                                    id: "formMedicalInformation.medicalConditionsHelpText.list.l3",
                                                    defaultMessage: "they may put your fellow travellers at risk."
                                                })
                                            )
                                        }
                                    })
                                )
                            }
                        })
                    }, (0, _forms.objInArrayFieldProps)({
                        findProp: "type",
                        findValue: "MEDICAL_CONDITIONS",
                        valueProp: "value",
                        WrappedComponent: _Input2.default
                    })))
                }, (0, _extends3.default)({}, (0, _forms.generateOverride)({
                    intl: intl,
                    id: "medicalNotesOverride",
                    requirement: medicalConditionsReq,
                    overrideLabels: _forms2.formOverrides.medicalInformation.MEDICAL_CONDITIONS,
                    bookingId: bookingId,
                    customOnChange: function customOnChange(checked) {
                        return handleCheckboxChange("medicalConditionsChecked", checked);
                    }
                }))]
            }),
            _react2.default.createElement(_FieldSet2.default, {
                requirement: riskToOthersReq,
                fields: [{
                    id: "riskToOthers",
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "formMedicalInformation.riskToOthers",
                        defaultMessage: "Risk To Others"
                    }),
                    field: _react2.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                        id: "riskToOthers",
                        name: paths.medicalNotesValuePath + ".medical_details",
                        hiddenValues: hiddenValues,
                        type: "textarea",
                        customDisabled: riskToOthersChecked,
                        requirement: riskToOthersReq,
                        helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "formMedicalInformation.riskToOthersHelpText",
                            defaultMessage: "List any pre-existing medical conditions that may put your fellow travellers at risk."
                        })
                    }, (0, _forms.objInArrayFieldProps)({
                        findProp: "type",
                        findValue: "RISK_TO_OTHERS",
                        valueProp: "value",
                        WrappedComponent: _Input2.default
                    })))
                }, (0, _extends3.default)({}, (0, _forms.generateOverride)({
                    intl: intl,
                    id: "riskToOthersOverride",
                    requirement: riskToOthersReq,
                    overrideLabels: _forms2.formOverrides.medicalInformation.RISK_TO_OTHERS,
                    bookingId: bookingId,
                    customOnChange: function customOnChange(checked) {
                        return handleCheckboxChange("riskToOthersChecked", checked);
                    }
                }))]
            }),
            _react2.default.createElement(_FieldSet2.default, {
                requirement: mobilityIssuesReq,
                fields: [{
                    id: "mobilityIssues",
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "formMedicalInformation.mobilityIssues",
                        defaultMessage: "Mobility Issues"
                    }),
                    field: _react2.default.createElement(_reduxForm.Field, (0, _extends3.default)({
                        id: "mobilityIssues",
                        name: paths.medicalNotesValuePath + ".medical_details",
                        hiddenValues: hiddenValues,
                        type: "textarea",
                        customDisabled: mobilityIssuesChecked,
                        requirement: mobilityIssuesReq,
                        helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "formMedicalInformation.mobilityIssuesHelpText",
                            defaultMessage: "If you have any mobility issues, please list them ONLY if they may impact your participation in any of the activities on your chosen trip(s)."
                        })
                    }, (0, _forms.objInArrayFieldProps)({
                        findProp: "type",
                        findValue: "MOBILITY_ISSUES",
                        valueProp: "value",
                        WrappedComponent: _Input2.default
                    })))
                }, (0, _extends3.default)({}, (0, _forms.generateOverride)({
                    intl: intl,
                    id: "mobilityIssuesOverride",
                    requirement: mobilityIssuesReq,
                    overrideLabels: _forms2.formOverrides.medicalInformation.MOBILITY_ISSUES,
                    bookingId: bookingId,
                    customOnChange: function customOnChange(checked) {
                        return handleCheckboxChange("mobilityIssuesChecked", checked);
                    }
                }))]
            }),
            medicalFormReq && _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(_FormStubText2.default, {
                    stubText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "formMedicalInformation.medicalFormStub",
                        defaultMessage: "{stubText}",
                        values: {
                            stubText: _react2.default.createElement(
                                "div",
                                null,
                                _react2.default.createElement(
                                    "h4",
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: "formMedicalInformation.medicalFormStubTitle",
                                        defaultMessage: "Medical Form"
                                    })
                                ),
                                _react2.default.createElement(
                                    "p",
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: "formMedicalInformation.medicalFormStubText",
                                        defaultMessage: "We need you to submit a medical form before your adventure."
                                    })
                                )
                            )
                        }
                    })
                }),
                _react2.default.createElement(_FieldSet2.default, {
                    className: "single-col",
                    requirement: medicalFormReq,
                    fields: [{
                        label: medicalFormReq.status === "INCOMPLETE" ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "formLabels.stubCompletionMedicalPrompt",
                            values: {
                                link: _react2.default.createElement(
                                    "a",
                                    {
                                        href: "https://media.gadventures.com/media-server/dynamic/admin/flatpages/expedition-medical-form-july2019.pdf",
                                        target: "_blank",
                                        rel: "noopener noreferrer"
                                    },
                                    "here"
                                )
                            }
                        }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: "formLabels.stubComplete" })
                    }]
                })
            ),
            _react2.default.createElement(_FieldSet2.default, {
                requirement: dietaryRestrictionsReq,
                fields: [{
                    id: "dietaryRestrictions",
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: "formMedicalInformation.dietaryRestrictions",
                        defaultMessage: "Food allergies & Dietary Restrictions"
                    }),
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: "dietaryRestrictions",
                        name: paths.dietaryRestrictionsValuePath + ".meal_notes",
                        hiddenValues: hiddenValues,
                        component: _Input2.default,
                        type: "textarea",
                        customDisabled: dietaryRestrictionsChecked,
                        requirement: dietaryRestrictionsReq,
                        helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "formMedicalInformation.dietaryRestrictionsHelpText",
                            defaultMessage: "List any food allergies or special meal requirements that we should be aware of prior to you leaving for your trip."
                        })
                    })
                }, (0, _extends3.default)({}, (0, _forms.generateOverride)({
                    intl: intl,
                    id: "dietaryRestrictionsOverride",
                    requirement: dietaryRestrictionsReq,
                    overrideLabels: _forms2.formOverrides.medicalInformation.DIETARY_RESTRICTIONS,
                    bookingId: bookingId,
                    initialValues: initialValues,
                    customOnChange: function customOnChange(checked) {
                        return handleCheckboxChange("dietaryRestrictionsChecked", checked);
                    }
                }))]
            }),
            _react2.default.createElement(_FormSubmit2.default, {
                handleSubmit: handleSubmit,
                invalid: invalid,
                pristine: pristine,
                submitting: submitting,
                submitSucceeded: submitSucceeded,
                isFetchingRequirementData: isFetchingRequirementData
            })
        )
    );
};

MedicalInformationBase.propTypes = {
    intl: _propTypes2.default.object.isRequired,
    initialValues: _propTypes2.default.object.isRequired,
    hiddenValues: _propTypes2.default.object.isRequired,
    checkinUrl: _propTypes2.default.string.isRequired,
    requirementsByCode: _propTypes2.default.object.isRequired,
    medicalInfoPax: _propTypes2.default.object.isRequired,
    isMedicalInfoPax: _propTypes2.default.bool.isRequired,
    bookingId: _propTypes2.default.string.isRequired,
    bookingCompanyId: _propTypes2.default.number.isRequired,
    isFetchingRequirementData: _propTypes2.default.bool.isRequired,
    handleSubmit: _propTypes2.default.func.isRequired,
    error: _propTypes2.default.string,
    invalid: _propTypes2.default.bool,
    pristine: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    submitSucceeded: _propTypes2.default.bool,
    submitFailed: _propTypes2.default.bool
};

var checkboxSelector = (0, _reduxForm.formValueSelector)(CHECKBOX_STATE);
var mapCheckboxDispatch = { changeCheckboxValue: _reduxForm.change };

var mapCheckboxState = function mapCheckboxState(state) {
    return {
        medicalConditionsChecked: !!checkboxSelector(state, "medicalConditionsChecked"),
        riskToOthersChecked: !!checkboxSelector(state, "riskToOthersChecked"),
        mobilityIssuesChecked: !!checkboxSelector(state, "mobilityIssuesChecked"),
        dietaryRestrictionsChecked: !!checkboxSelector(state, "dietaryRestrictionsChecked")
    };
};

var MedicalInformation = (0, _pacomo.pacomoTransformer)(MedicalInformationBase);

exports.default = (0, _reactRedux.connect)(mapCheckboxState, mapCheckboxDispatch)((0, _reactIntl.injectIntl)((0, _reduxForm.reduxForm)({
    form: FORM_STATE,
    enableReinitialize: true
})(MedicalInformation)));
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/forms/MedicalInformation.js
// module id = 1323
// module chunks = 0